import { BodyText, Image } from "@0xsquid/ui";
import React from "react";
import { chains, getChainImage, getTokenImage } from "../../utils/constants";
import { formatTokenAmount } from "../../utils/formatting";

interface TransferProps {
  chain: string | undefined;
  token: {
    address: string | undefined;
    chainId: string | undefined;
    decimals: string | undefined;
    symbol: string | undefined;
  };
  amount: string | undefined;
}

export function TransferDetails({ amount, chain, token }: TransferProps) {
  return (
    <div className="tw-flex tw-items-center tw-gap-squid-xxs tw-flex-1 tw-self-stretch tw-text-grey-300">
      <Image
        src={getChainImage(chains[chain || "unknown"])}
        rounded="xxs"
        size="medium"
        alt={chain}
      />

      <BodyText size="small" className="tw-text-grey-300 tw-capitalize">
        {chains[chain || "unknown"]}
      </BodyText>

      <Image src={getTokenImage(token)} rounded="full" size="medium" alt={token.symbol} />

      <BodyText
        size="small"
        className="tw-text-grey-300 tw-w-full tw-overflow-hidden tw-text-ellipsis tw-whitespace-nowrap"
      >
        {formatTokenAmount(
          amount || "0",
          (token.decimals !== undefined
            ? token.decimals
            : token.symbol === "USDC"
              ? "6"
              : "18"
          ).toString(),
        )}{" "}
        {token.symbol}
      </BodyText>
    </div>
  );
}
